import { forwardRef, type ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  block?: boolean;
}

// Botón principal: amarillo micro con texto asfalto (9,91:1). Nunca texto blanco sobre amarillo (DESIGN.md).
const variants: Record<ButtonVariant, string> = {
  primary: 'bg-action text-ink hover:bg-action-hover disabled:bg-gray-200 disabled:text-gray-500',
  secondary: 'bg-white text-ink border border-line hover:bg-mist disabled:text-gray-500',
  ghost: 'bg-transparent text-green hover:underline disabled:text-gray-500',
  danger: 'bg-error text-white hover:brightness-95 disabled:bg-gray-200 disabled:text-gray-500',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-3 text-base min-h-12',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'md', loading = false, block = false, className = '', disabled, children, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`inline-flex items-center justify-center gap-2 rounded-md font-semibold transition-colors duration-100 disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${block ? 'w-full' : ''} ${className}`}
      {...rest}
    >
      {loading && <span className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" aria-hidden="true" />}
      {children}
    </button>
  );
});
